import { createContext, RefObject } from 'react';
import { GenericModalProps } from '@layout/components/Modal/Modal.types';

export const GenericModalContext = createContext<RefObject<GenericModalProps> | null>(null);

type GeneralContextProps = {
  host: string;
  windowWidth?: number;
  searchQuery?: string;
  setSearchQuery?: (key: string) => void;
  isPlaying: boolean;
  setIsPlaying: (value: boolean) => void;
  showAppBanner: boolean;
  setShowAppBanner: (value: boolean) => void;
};

export const GeneralContext = createContext<GeneralContextProps>({
  host: '',
  isPlaying: false,
  setIsPlaying: () => {},
  setShowAppBanner: () => {},
  showAppBanner: true,
});
